import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import BlockIcon from '@mui/icons-material/Block';
import CloseIcon from '@mui/icons-material/Close';

const DECLINE_BUTTON_DESCRIPTION = 'Decline feedback';
const CLOSE_BUTTON_DESCRIPTION = 'Close';

interface ITopBarProps {
  showDecline: boolean;
  disabled: boolean;
  onClose: () => void;
  onDecline: () => void;
}

export default function TopBar(props: ITopBarProps) {
  const { disabled, showDecline, onClose, onDecline } = props;

  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleDecline = () => {
    setDialogOpen(false);
    onDecline();
  };

  return (
    <>
      <Box sx={{ mb: -2, textAlign: 'right' }}>
        {showDecline &&
          <Tooltip title={DECLINE_BUTTON_DESCRIPTION}>
            <>
              <IconButton
                size="small"
                aria-label={DECLINE_BUTTON_DESCRIPTION}
                disabled={disabled}
                onClick={handleOpenDialog}
              >
                <BlockIcon />
              </IconButton>
            </>
          </Tooltip>
        }

        <Tooltip title={CLOSE_BUTTON_DESCRIPTION}>
          <>
            <IconButton
              size="small"
              aria-label={CLOSE_BUTTON_DESCRIPTION}
              disabled={disabled}
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </>
        </Tooltip>
      </Box>

      <Dialog
        open={dialogOpen}
        onClose={handleCloseDialog}
      >
        <DialogTitle>
          Decline Feedback
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            Are you sure you don't want to provide a rating?
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDecline}>Yes, don't ask again</Button>
          <Button onClick={handleCloseDialog}>Cancel</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
